import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowRight, Eye, X, Brain } from "lucide-react";

export default function RevealPage() {
  const navigate = useNavigate();

  return (
    <div className="reveal-theme">
      <div className="max-w-3xl mx-auto px-6 py-16 sm:py-24">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 mb-8">
          <ShieldAlert className="w-3.5 h-3.5 text-red-400" />
          <span className="text-xs uppercase tracking-widest text-red-300">
            Sesi Berakhir
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6">
          Apa yang baru saja terjadi
          <br />
          <span className="text-amber-400">bukan keberuntungan.</span>
        </h1>

        <p className="text-lg text-slate-300 leading-relaxed mb-12 max-w-2xl">
          Itu adalah keputusan admin. Setiap kemenangan dan kekalahan dalam simulasi ini
          dikendalikan dari sebuah dashboard yang tidak pernah Anda lihat sebagai pemain.
          Persis seperti yang dilakukan situs judi online sebenarnya.
        </p>

        <div className="grid sm:grid-cols-3 gap-4 mb-12">
          <div className="p-5 bg-slate-800/50 border border-slate-700 rounded-lg">
            <Eye className="w-5 h-5 text-amber-400 mb-3" />
            <h3 className="font-semibold mb-1.5">Admin Lihat Saldo Anda</h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Mereka tahu siapa yang hampir bangkrut, siapa yang masih punya uang banyak.
            </p>
          </div>
          <div className="p-5 bg-slate-800/50 border border-slate-700 rounded-lg">
            <Brain className="w-5 h-5 text-amber-400 mb-3" />
            <h3 className="font-semibold mb-1.5">Kemenangan Dirancang</h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Anda dibuat menang sesekali agar terus bermain — bukan karena beruntung.
            </p>
          </div>
          <div className="p-5 bg-slate-800/50 border border-slate-700 rounded-lg">
            <X className="w-5 h-5 text-red-400 mb-3" />
            <h3 className="font-semibold mb-1.5">Bandar Selalu Menang</h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Sistemnya dirancang agar dalam jangka panjang, uang peserta selalu habis.
            </p>
          </div>
        </div>

        <div className="p-6 bg-amber-500/10 border border-amber-500/30 rounded-lg mb-10">
          <p className="text-amber-100 leading-relaxed">
            <span className="font-semibold text-amber-300">Pesan untuk Anda:</span> Judi
            online bukan permainan keberuntungan, tapi sistem yang dirancang untuk
            mengambil uang Anda. Sekali Anda paham mekanismenya, Anda tidak akan tergoda
            lagi.
          </p>
        </div>

        <Button
          data-testid="back-home-button"
          onClick={() => navigate("/")}
          className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-semibold h-12 px-6"
        >
          Kembali ke Awal
          <ArrowRight className="w-4 h-4 ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
